module.exports = __webpack_public_path__ + "img/letter.f74afb35.jpg";